var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "60 30 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 268,
    r: 159,
    fill: "#A5DA05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 271L198 316L296 214",
    stroke: "#1D1D1D",
    strokeWidth: 27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 52L324 92",
    stroke: "#1D1D1D",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381 78L358 114",
    stroke: "#1D1D1D",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434 144L392 158",
    stroke: "#1D1D1D",
    strokeWidth: 19,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishSuccess);
export default __webpack_public_path__ + "static/media/publish_success.9b93d1bc7fac388ef5bef8aec226f7a2.svg";
export { ForwardRef as ReactComponent };